import { Component, inject, input, linkedSignal } from '@angular/core';
import { Illustration } from '@app/models/global.model';
import { IllustrationSectionComponent } from '@app/components/illustration-section/illustration-section.component';
import { MobiUiExpanderComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { TextComponent } from '@app/components/text/text.component';
import { ParagraphPgScs } from '@app/models/paragraph.model';
import { ComponentSharedModule } from '@app/modules/component.shared.module';
import { BreakpointService } from '@app/services/breakpoint.service';
import { ShowHiddenService } from '@app/services/show-hidden.service';

@Component({
  selector: 'mobi-service-infobox',
  templateUrl: './service-infobox.component.html',
  styleUrls: ['./service-infobox.component.scss'],
  standalone: true,
  imports: [
    ComponentSharedModule,
    IllustrationSectionComponent,
    MobiUiExpanderComponent,
    TextComponent,
  ],
})
export class ServiceInfoboxComponent {
  readonly superTitle = input<string | undefined>('');
  readonly title = input<string | undefined>('');
  readonly services = input<ReadonlyArray<ParagraphPgScs> | undefined>([]);
  readonly illustration = input<Illustration | undefined>();
  readonly sectionId = input<string | undefined>();

  breakpoint = inject(BreakpointService);
  #showHiddenService = inject(ShowHiddenService);
  readonly expandedByService = linkedSignal<Record<string, boolean>>(() => {
    const expanded = this.#showHiddenService.showHidden();
    return Object.fromEntries(
      (this.services() ?? []).map((service) => [service.id, expanded])
    );
  });

  setExpanded(id: string, expanded: boolean): void {
    this.expandedByService.update((state) => ({ ...state, [id]: expanded }));
  }
}
